<template>
  <div class="group-box">
    <div class="title">欢迎加入明明城堡</div>
    <img class="check_img" :src="require('@/assets/images/check.png')" />
    <div class="tip_text">已获得 7 天课程体验</div>
    <div class="tip_text">关注公众号【明明城堡】即可体验全部课程</div>
    <img class="follow_img" :src="require('@/assets/images/follow.png')" />
    <div class="start_btn" @click="navToClassroom">立即看动画学知识</div>
    <ServiceStick />
  </div>
</template>

<script>
import ServiceStick from '@/components/ServiceStick'
export default {
  name: 'earlyAccessGuide',
  data() {
    return {
      showServicePopup: false
    }
  },
  components: {
    ServiceStick
  },
  async mounted() {
    console.log('1元体验7天页面支付成功引导页面')
    await this.weixinAuth()
  },
  methods: {
    navToClassroom() {
      this.$router.push({
        name: 'classroom'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.group-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
  }

  .check_img {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 60px;
  }

  .tip_text {
    margin-top: 10px;
    color: #FF563E;
    font-size: 14px;
  }

  .follow_img {
    margin-top: 20px;
    width: 80%;
  }

  .start_btn {
    width: 80%;
    margin-top: 20px;
    color: #FF563E;
    font-size: 14px;
    border-color: #FF563E;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }

  .guide_img {
    width: 60px;
    position: fixed;
    bottom: 20%;
    right: 0px;
  }
}
</style>
